import { COLORS, Z_INDEX, BORDER_RADIUS, SPACING } from '../utils/constants';

export const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: COLORS.overlayScrim,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: Z_INDEX.modal,
};

export const modalStyle = {
  background: COLORS.background,
  borderRadius: BORDER_RADIUS.xl,
  padding: SPACING.xxxl,
  maxWidth: '480px',
  width: '90%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
  fontFamily: 'Outfit, -apple-system, Roboto, Helvetica, sans-serif',
};

export const iconContainerStyle = {
  width: '64px',
  height: '64px',
  borderRadius: BORDER_RADIUS.full,
  background: COLORS.primaryGradient,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: SPACING.xl,
};

export const titleStyle = {
  fontSize: '24px',
  fontWeight: '600',
  color: COLORS.text,
  marginBottom: SPACING.sm,
  textAlign: 'center',
};

export const descriptionStyle = {
  fontSize: '14px',
  color: COLORS.textSecondary,
  marginBottom: SPACING.xxl,
  textAlign: 'center',
};

export const buttonStyle = {
  width: '100%',
  padding: `${SPACING.md} ${SPACING.xxl}`,
  background: COLORS.primaryGradient,
  color: COLORS.background,
  border: 'none',
  borderRadius: BORDER_RADIUS.md,
  fontSize: '16px',
  fontWeight: '500',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
};

export const buttonContainerStyle = {
  display: 'flex',
  gap: SPACING.md,
  width: '100%',
};

export const closeButtonStyle = {
  flex: 1,
  padding: `${SPACING.md} ${SPACING.xxl}`,
  background: COLORS.backgroundGrey,
  color: COLORS.text,
  border: 'none',
  borderRadius: BORDER_RADIUS.md,
  fontSize: '16px',
  fontWeight: '500',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
};

export const inputStyle = {
  width: '100%',
  padding: `${SPACING.md} ${SPACING.lg}`,
  border: `1px solid ${COLORS.border}`,
  borderRadius: BORDER_RADIUS.md,
  background: COLORS.backgroundGrey,
  color: COLORS.text,
  fontSize: '14px',
  marginBottom: SPACING.xxl,
  outline: 'none',
  boxSizing: 'border-box',
  fontFamily: 'monospace',
};

export const labelStyle = {
  fontSize: '12px',
  color: COLORS.textSecondary,
  marginBottom: SPACING.sm,
  alignSelf: 'flex-start',
  width: '100%',
};

